import { Component } from '@angular/core';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { NavController, NavParams } from 'ionic-angular';
import { AlphabetizedCollection } from '../../models/alphabetized-collection';
import { Chapter } from '../../models/Chapter';
import { DirectoryService } from '../../providers/directory-service';
import { DesktopService } from '../../providers/desktop-service';

@Component({
    selector: 'page-browse-directory',
    templateUrl: 'browse-directory.html'
})
export class BrowseDirectoryPage {

    public alphabetized: AlphabetizedCollection<Chapter>;
    public chapters: Chapter[] = null;
    public isDesktop: boolean = false;

    constructor(
        public analytics: FirebaseAnalytics,
        public desktop: DesktopService,
        public directoryService: DirectoryService,
        public navCtrl: NavController,
        public navParams: NavParams,
        private desktopService: DesktopService,
    ) {
        this.chapters = this.navParams.get('chapters');
        this.alphabetized = new AlphabetizedCollection(this.chapters, chapter => {
            return chapter.title.charAt(0).toUpperCase()
        }, (a, b) => {
            const title_a = AlphabetizedCollection.removeSpecialCharsAndLowercase(a.title);
            const title_b = AlphabetizedCollection.removeSpecialCharsAndLowercase(b.title);

            if (title_a < title_b) return -1;
            if (title_a > title_b) return 1;
            return 0;
        });
    }

    public ngAfterViewInit() {
        this.isDesktop = this.desktop.isDesktop();
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Chapters');
    }

    public goToChapter(chapter: Chapter) {
        this.directoryService.showChapter(chapter);
    }

}



// WEBPACK FOOTER //
// ./src/pages/browse-directory/browse-directory.ts